import type { PropsWithChildren } from 'react';
import { Icon, IconName } from '../Icons';

import { EmptyMessage } from './styles';

export function NoDataMessage({ children }: PropsWithChildren) {
  return (
    <EmptyMessage>
      <Icon icon={IconName.ExclamationCircle} color="Subtle" />
      {children}
    </EmptyMessage>
  );
}
